const SECTION_INNER =
  "max-w-7xl mx-auto px-6 sm:px-12 pt-4 sm:pt-6 pb-24 sm:pb-32";

export { SECTION_INNER };
